<script>
export default {
  props: {
    iconClass: {
      type: Object,
      default: () => {
        return { fas: true, 'fa-trash-alt': true, 'text-danger': true };
      },
    },
    error: { type: Boolean, default: false },
  },
  data() {
    return {
      animationStatus: 0,
      lastClickTime: 0,
    };
  },
  methods: {
    iconClicked() {
      if (this.animationStatus > 2) {
        this.$emit('reset');
        this.animationStatus = 0;
      } else if (this.animationStatus == 1) {
        this.animationStatus = 2;
      } else {
        this.animationStatus = 1;
        this.lastClickTime = Date.now();
      }
    },
    confirmClicked() {
      let diff = Date.now() - this.lastClickTime;

      if (diff > 220) {
        this.animationStatus = 3;
        this.$emit('clicked');
      }
    },
  },
  watch: {
    error(err) {
      if (err) {
        this.animationStatus = 4;
      }
    },
  },
};
</script>

<template>
  <div class="main-delete-wrapper">
    <div
      class="delete-button-wrapper"
      :class="{
        growDeleteAnim: animationStatus == 1,
        ungrowDeleteAnim: animationStatus > 1,
      }"
    >
      <div class="trash-wrapper" @click="iconClicked">
        <i
          v-if="animationStatus == 4"
          class="fas fa-exclamation text-danger"
          style="margin-left: 4px; margin-right: 4px"
        ></i>
        <i
          v-else-if="animationStatus == 3"
          class="bx bx-loader-alt bx-spin text-warning"
          style="margin-left: -4px; font-size: 18px"
        >
        </i>
        <i
          v-else
          :class="
            animationStatus == 0
              ? iconClass
              : animationStatus == 2
              ? { ...iconClass, deleteButtonUnAnim: true }
              : {
                  fas: true,
                  'fa-times': true,
                  'text-danger': true,
                  deleteButtonAnim: true,
                }
          "
        ></i>
      </div>
      <span
        class="confirm-text text-success"
        :class="{ 'extra-padding': $t('general.confirmInterog').length < 9 }"
        @click="confirmClicked()"
      >
        {{ $t('general.confirmInterog') }}
      </span>
    </div>
  </div>
</template>

<style>
.main-delete-wrapper {
  width: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.delete-button-wrapper {
  width: 31px;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 150px;
  border: 1px solid transparent;
}
.confirm-text {
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}
.trash-wrapper {
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-items: center;
  padding: 5px 5px 5px 10px;
}

.extra-padding {
  padding-left: 3px;
}

.deleteButtonAnim {
  animation: delbanim 0.7s forwards;
}

@keyframes delbanim {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(180deg);
  }
}

.deleteButtonUnAnim {
  animation: delbunanim 0.43s forwards;
}

@keyframes delbunanim {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(0);
  }
}

.growDeleteAnim {
  animation: delgrowanim 0.43s forwards;
}

@keyframes delgrowanim {
  from {
    width: 31px;
    border-color: transparent;
  }

  to {
    width: 100px;
    stroke-dashoffset: 0;
    border-color: #a2a4b3;
  }
}

.ungrowDeleteAnim {
  animation: delungrowanim 0.43s forwards;
}

@keyframes delungrowanim {
  from {
    width: 100px;
    stroke-dashoffset: 0;
    border-color: #a2a4b3;
  }

  to {
    width: 31px;
    border-color: transparent;
  }
}
</style>